import { FC } from "react";
import { Box, Skeleton } from "@mui/material";
import { styles } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureAreas/styles";
import uuid from "src/utils/jsHelpers/uuid";

interface ISkeletons {
  limit: number;
  isMobile: boolean;
}

const Skeletons: FC<ISkeletons> = ({ limit, isMobile }) => {
  const areasSkeleton = (areasQuantity: number) =>
    [...Array(areasQuantity)].map(() => (
      <Skeleton
        sx={{ borderRadius: "16px" }}
        variant="rectangular"
        height={233}
        key={uuid()}
      />
    ));

  return (
    <>
      <Box sx={styles.Skeletons.paginationSkeleton}>
        <Skeleton width={300} />
      </Box>
      <Box
        sx={{
          ...styles.Skeletons.areaSkeletonsContainer,
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          gap: 2,
          marginTop: 2,
        }}
      >
        {areasSkeleton(limit)}
      </Box>
      <Box sx={styles.Skeletons.paginationSkeleton}>
        <Skeleton width={300} />
      </Box>
    </>
  );
};

export default Skeletons;
